import {
  MDSSessionAction,
  MDSSessionSetCurrentSessionIdAction,
} from "../../mds-session-context.types";

export enum MDSSessionSessionAction {
  SetCurrentSessionId = MDSSessionAction.SetCurrentSessionId,
}

export type MDSSessionSessionActionTypes = MDSSessionSetCurrentSessionIdAction;
